/**
 * A display figure: the number a panel, a tile or a meter is built around.
 *
 * Proportional figures, not `tabular-nums`: equal-width digits exist so columns of
 * numbers line up, and at this size they make `121` read loose and mechanical. A
 * row of figures that *does* line up (`FigureRow`, spec 226) adds `tabular-nums`
 * beside it; a single figure never does.
 *
 * Shared because three surfaces set one — the Spend meter's amount, the
 * organization console's tiles and header — and each had picked its own size
 * before spec 074 FR-003 named this one. It lived in `workspace-overview`'s
 * private style module and was imported across features from there, the same
 * reach `SECTION_HEADING` made before it moved here; that module re-exports it
 * so its callers are unchanged (spec 226 research R3).
 */
export const DISPLAY_FIGURE = 'text-3xl leading-none font-light tracking-tight';
